import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private readonly TURNSTILE_VALIDATION_URL = '/auth/validate-turnstile';

	constructor(private authService: AuthService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		const token = this.authService.getToken();

		if (!token || request.url.includes(this.TURNSTILE_VALIDATION_URL)) {
			return next.handle(request);
		}

		return next.handle(
			request.clone({
				setHeaders: { Authorization: `Bearer ${token}` },
			})
		);
	}
}
